import type { ValueTypeEntry } from "../index";
import { MultiChips, MultiEditor, type MultiOptions, type MultiValue } from "./multi-editor";

export type { MultiOptions } from "./multi-editor";

/**
 * Built-in `multi-value` field type. CRITICAL: registered under the
 * canonical `"multi-value"` key (with hyphen) — that's the
 * `TableValueType` string in `packages/types/src/tabular-editor.ts`. A
 * registration under `"multi"` would silently fall back to text.
 *
 * Renderer reimplements a minimal `ExpandableList` inline rather than
 * importing it from `@quovy/ui` — `@quovy/ui` already depends on
 * `@quovy/field-types`, so a direct import would close the cycle.
 */
export const multiType: ValueTypeEntry<MultiValue, MultiOptions> = {
  name: "multi-value",
  format(value) {
    if (!value || value.length === 0) return "";
    return value.join(", ");
  },
  render({ value, options }) {
    if (!value || value.length === 0) return null;
    return <MultiChips value={value} options={options ?? {}} />;
  },
  display({ value, options }) {
    const narrowed: MultiValue = Array.isArray(value) ? (value as string[]) : null;
    if (!narrowed || narrowed.length === 0) return null;
    return <MultiChips value={narrowed} options={options ?? {}} />;
  },
  edit({ value, onCommit, onCancel, options }) {
    return (
      <MultiEditor
        value={value}
        options={options?.options ?? []}
        onCommit={onCommit}
        onCancel={onCancel}
      />
    );
  },
};
